import React from 'react';
import styled from 'styled-components/macro';
import Card from './Card';
import { connect } from 'react-redux';
import { fetchFavourites, fetchSideNav } from '../actions';
import translate from './TranslateHOC';
import { CardGridLoading } from '../v2/components/loading/CardGridLoading';
import LoadingError from './alerts/LoadingError';

function CardGrid({
  strings,
  items,
  itemsIsLoading,
  itemsHasErrored,
  itemsLimit,
  favourites,
  itemSelectedId,
  signed,
  cardBtn,
  limitInt = parseInt(itemsLimit, 10),
  checkAvail,
  orientation,
  checkToday,
  gridType,
  playPos,
  billingBool,
  countBool,
  isSideNavToggled,
}) {
  const limitCards =
    limitInt && limitInt > 0 ? limitInt : Object.keys(items).length;
  const currentPlayPos = playPos === true ? true : false;
  const { length: itemsLength } = Object.keys(items);
  const noPadding = gridType?.includes('no-padding');
  const highlights = gridType?.includes('highlights');
  const az = gridType?.includes('az');
  const programme = gridType?.includes('programme');

  if (itemsIsLoading) {
    return (
      <CardGridContainer noPadding={noPadding}>
        <CardGridLoading orientation={orientation} />
      </CardGridContainer>
    );
  }

  if (itemsHasErrored) {
    return (
      <CardGridContainer noPadding={noPadding}>
        <LoadingError errorMessage={strings.sorryLoading} />
      </CardGridContainer>
    );
  }

  return (
    <CardGridContainer noPadding={noPadding} programme={programme}>
      {itemsLength > 0 && (
        <CardGridInner
          className={'card-grid__inner ' + (gridType ? gridType : '')}
          navClosed={!isSideNavToggled}
          navOpen={isSideNavToggled}
          highlights={highlights}
          az={az}
          type={gridType}
          noPadding={noPadding}
        >
          {Object.keys(items)
            .slice(0, limitCards)
            .map((key) => (
              <Card
                key={key}
                index={key}
                orientation={orientation}
                details={items[key]}
                isFav={favourites?.length > 0 && favourites.includes(key)}
                billingBool={billingBool}
                countBool={countBool}
                playPos={currentPlayPos}
                signed={signed}
                cardBtn={cardBtn}
                checkAvail={checkAvail}
                active={itemSelectedId === items[key].id}
                isToday={checkToday}
                type={gridType}
              />
            ))}
        </CardGridInner>
      )}
    </CardGridContainer>
  );
}

const CardGridContainer = styled.div`
  ${(props) =>
    props.gridType === 'centered' &&
    `
    margin: auto;
    max-width: 1595px;
    padding: 12px 15px 32px;
  `}
  ${(props) => props.noPadding && `padding: 0`};
  ${(props) =>
    props.gridType === 'card-grid-container--raised' && `z-index: 10`};
  ${(props) =>
    props.gridType === 'card-grid-container--no-line' &&
    `h2 { box-shadow: none;}`};
  ${(props) => props.programme && `padding: 12px 0 32px;`};
  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const CardGridInner = styled.div`
  padding: 0 15px;
  ${(props) => props.highlights && `padding: 0;`};
  ${(props) =>
    props.az &&
    `grid-template-columns: repeat(auto-fill, minmax(100%, auto)) !important;`};
  ${(props) => props.navClosed && props.az && `max-width: none !important;`};
  ${(props) => props.noPadding && `padding: 0;`};
  @supports (display: grid) {
    display: grid;
    grid-gap: 16px 20px;
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (min-width: 678px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: 768px) {
    padding: 0 15px 0 0;
    ${(props) =>
      props.highlights && `grid-template-columns: repeat(3, 1fr) !important;`};
    ${(props) =>
      props.az &&
      `grid-template-columns: repeat(auto-fill, minmax(260px, auto)) !important;`};
    ${(props) => props.noPadding && `padding: 0;`};
  }
  @media screen and (min-width: 1024px) {
    ${(props) => props.navClosed && `grid-template-columns: repeat(4, 1fr);`};
    ${(props) =>
      props.highlights &&
      props.navClosed &&
      `grid-template-columns: repeat(4, 1fr) !important;`};
  }
  @media screen and (min-width: 1200px) {
    ${(props) => props.navOpen && `grid-template-columns: repeat(4, 1fr);`};
    ${(props) => props.navClosed && `grid-template-columns: repeat(5, 1fr);`};
  }
  @media screen and (min-width: 1270px) {
    ${(props) =>
      props.highlights && `grid-template-columns: repeat(4, 1fr) !important;`};
    ${(props) =>
      props.highlights &&
      props.navClosed &&
      `grid-template-columns: repeat(4, 1fr) !important;`};
  }
  @media screen and (min-width: 1440px) {
    ${(props) => props.navOpen && `grid-template-columns: repeat(5, 1fr);`};
    ${(props) => props.navClosed && `grid-template-columns: repeat(6, 1fr);`};
    ${(props) =>
      props.highlights &&
      props.navClosed &&
      `grid-template-columns: repeat(5, 1fr) !important;`};
  }
  @media screen and (min-width: 1830px) {
    ${(props) => props.navOpen && `grid-template-columns: repeat(6, 1fr);`};
    ${(props) => props.navClosed && `grid-template-columns: repeat(7, 1fr);`};
    ${(props) =>
      props.highlights && `grid-template-columns: repeat(5, 1fr) !important;`};
  @media screen and (min-width: 2078px) {
    ${(props) => props.navOpen && `grid-template-columns: repeat(7, 1fr);`};
    ${(props) => props.navClosed && `grid-template-columns: repeat(8, 1fr);`};
  }
  @media screen and (min-width: 2326px) {
    ${(props) => props.navOpen && `max-width: 2002px;`};
    ${(props) => props.navClosed && `max-width: 2230px;`};
  }
`;

function mapStateToProps(state) {
  return {
    favourites: state.favourites,
    isSideNavToggled: state.sideNav,
  };
}

export default translate(
  connect(mapStateToProps, { fetchFavourites, fetchSideNav })(CardGrid)
);
